<template>
    <div 
    class="form-group" 
    :class="formGroupClass">
        <form-label 
        v-if="name">
            {{name}}

            <i 
            v-tippy
            v-if="content"
            :content="content"
            class="bi bi-info-circle ml-3"></i>
        </form-label>

        <div 
        class="form-check-group"
        :class="inline ? 'inline' : ''">

            <div class="form-check"
            :key="option.value"
            v-for="(option, key) in options">

              <input 
              class="form-check-input" 
              type="radio"
              :name="id"
              :id="id+'-'+option.value" 
              @input="input"
              :checked="option.value == val"
              :value="option.value">

              <label 
              class="form-check-label" 
              :class="option.sublabel ? 'has-sublabel' : ''"
              :for="id+'-'+option.value">
                <div class="d-flex align-items-center">
                    <i 
                    v-if="option.desc"
                    v-tippy
                    :content="option.desc"
                    class="bi bi-info-circle mr-4"></i>

                    <div>
                        <div class="label-value">
                            {{option.label}}
                        </div>

                        <div 
                        v-if="option.sublabel"
                        class="sublabel-value">
                            {{option.sublabel}}
                        </div>

                    </div>
                </div>
              </label>

            </div> <!-- /.form-check -->


        </div>

        <form-errors v-bind="{errors}" />
		
    </div>
</template>

<script>

    import { mapState } from 'vuex'

    export default {

        inheritAttrs: false,

        props: {
            id: {
                type: String,
                default() {
                    return `input-radio-${this._uid}`
                },
            },

            inline: {
                type: Boolean,
                default: false
            },

            options: {
                type: Array,
                default: () => []
            },

            formGroupClass: {
                type: [String, Array],
                default: ''
            },

            content: {
                type: String,
                default: "",
            },
			
            errors: {
                type: String,
                default: "",
            },

            value: [String, Number, Boolean, Array, Object],
            name: String,
            sublabel: String

        },

        computed: {

            val() {
                return this.value
            }

        },

        methods: {

            input(e) {
                this.$emit('input', e.target.value)
            }

        }
    }
</script>
